import { TIME_SLOT_TYPE } from "constants/order";
import { useListFunctionRole } from "hooks";
import moment from "moment";
import { REF_CODE_PATTERN } from "pages/Transport/utils";
import React from "react";
import { isInclusivelyAfterDay } from "react-dates";
import { useLocation } from "react-router-dom";

export const errorMessage = error => {
  const message =
    error.response && error.response.data
      ? error.response.data
      : { message: error.message };
  return { ...message };
};

export const formatDateTime = {
  DD_MM_YYYY: "DD-MM-YYYY",
  YYYY_MM_DD: "YYYY-MM-DD",
  DD_MM_YYYY_hh_mm: "DD-MM-YYYY hh:mm",
  DD_MM_YYYY_hh_mm_ss: "DD-MM-YYYY hh:mm:ss",
  YYYY_MM_DD_hh_mm_ss: "YYYY-MM-DD hh:mm:ss",
  DD_MM_YYYY_HH_mm: "DD-MM-YYYY HH:mm",
  DD_MM_YYYY_HH_MM_SS: "DD-MM-YYYY HH:mm:ss",
  YYYY_MM_DD_HH_mm_ss: "YYYY-MM-DD HH:mm:ss",
};

export const convertDateTime = (data, format, separate = "/") => {
  let result = "";

  if (data) {
    let momentData = null;

    for (;;) {
      if (String(Number(data)) === String(data)) {
        momentData = moment.unix(Number(data));
        break;
      }

      momentData = moment(data);
      break;
    }

    if (momentData.isValid()) {
      switch (format) {
        case formatDateTime.DD_MM_YYYY:
        case formatDateTime.YYYY_MM_DD:
        case formatDateTime.DD_MM_YYYY_HH_mm:
        case formatDateTime.DD_MM_YYYY_hh_mm:
        case formatDateTime.DD_MM_YYYY_hh_mm_ss:
        case formatDateTime.DD_MM_YYYY_HH_MM_SS:
        case formatDateTime.YYYY_MM_DD_HH_mm_ss:
          result = momentData.format(String(format).replace(/-/g, separate));
          break;
        default:
          result = momentData.format(
            String(formatDateTime.YYYY_MM_DD_hh_mm_ss).replace(/-/g, separate)
          );
          break;
      }
    }
  }

  return result;
};

export const CheckActionAccess = (action = "", defaultResult = false) => {
  const { data } = useListFunctionRole();
  //return true;

  if (data !== undefined && data.items?.length > 0 && action) {
    return data.items.some(item => item.functionName === action);
  }

  return defaultResult;
};

export const CheckActionAccessList = (dataList = [], key = "") => {
  const { data } = useListFunctionRole();
  const result = [];
  //return dataList;

  if (
    data !== undefined &&
    data.items?.length > 0 &&
    key &&
    dataList?.length > 0
  ) {
    dataList.forEach(item => {
      // If Not Exist Key => return data
      if (item[key] === undefined || !item[key]) {
        result.push(item);
        return;
      }

      if (data.items.some(x => x.functionName === item[key])) {
        result.push(item);
      }
    });
  }

  return result;
};

export const runSearchStickyJs = () => {
  window.onscroll = () => {
    func();
  };

  function func() {
    const searchSticky = document.getElementsByClassName("search-sticky")[0];
    if (searchSticky && window.screen.width > 990) {
      const navHeaderHeight =
        document.getElementsByClassName("navbar-header")[0]?.offsetHeight || 0;
      const topMenuHeight =
        document.getElementById("topnav-menu-content")?.offsetHeight || 0;
      const sticky = searchSticky.offsetTop;
      if (window.pageYOffset > sticky - navHeaderHeight - topMenuHeight) {
        searchSticky.classList.add("sticky");
        searchSticky.style.top = navHeaderHeight + topMenuHeight + "px";
      } else {
        searchSticky.classList.remove("sticky");
      }
    }
  }
};

export const useQueryRouter = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export const checkIncludeDate = (date, listDate) => {
  const dateCompare = date.format("YYYY-MM-DD");
  if (listDate.find(item => item === dateCompare)) {
    return true;
  }
  return false;
};

export const checkIncludeDateTime = (date, listDate) => {
  const dateCompare = date.format("YYYY-MM-DD");
  const findDate = listDate.find(item => item.date === dateCompare);
  if (findDate && checkEnoughADay(findDate.from_time, findDate.to_time)) {
    return true;
  }
  return false;
};

export const checkOutSideDate = (date, listDate, isCheckSunday = true) => {
  // Check is sunday
  if (isCheckSunday) {
    const today = new Date(date);
    if (
      // today.getDay() == 6 ||
      today.getDay() == 0
    ) {
      return true;
    }
  }
  //
  if (listDate.length > 0) {
    if (checkIncludeDate(date, listDate)) {
      return true;
    } else {
      return !isInclusivelyAfterDay(date, moment());
    }
  } else {
    return !isInclusivelyAfterDay(date, moment());
  }
};

export const checkOutSideDateAndTime = (
  date,
  listDate,
  isCheckSunday = true
) => {
  // Check is sunday
  if (isCheckSunday) {
    const today = new Date(date);
    if (today.getDay() == 0) {
      return true;
    }
  }
  //
  if (listDate.length > 0) {
    if (checkIncludeDateTime(date, listDate)) {
      return true;
    } else {
      return !isInclusivelyAfterDay(date, moment());
    }
  } else {
    return !isInclusivelyAfterDay(date, moment());
  }
};

export const checkIsInFixedDaysOff = (listDaysOff, date) => {
  const today = new Date(date);
  const day = today.getDay();

  if (listDaysOff && listDaysOff.length > 0 && listDaysOff.includes(`${day}`)) {
    return true;
  }

  return false;
};

export function splitDateRange(from_date, to_date) {
  const formatDay = "YYYY-MM-DD";
  const formatTime = "HH:mm:ss";

  const fromDate = new Date(moment(from_date).toISOString());
  const toDate = new Date(moment(to_date).toISOString());
  const fromDateFormat = moment(fromDate).format(formatDay);
  const toDateFormat = moment(toDate).format(formatDay);
  const fromTimeFormat = moment(fromDate).format(formatTime);
  const toTimeFormat = moment(toDate).format(formatTime);

  let result = [];

  for (
    let d = fromDate;
    moment(d, formatDay).isSameOrBefore(toDateFormat, "day");
    d.setDate(d.getDate() + 1)
  ) {
    let dateCurrent = moment(d).format(formatDay);

    result.push({
      date: dateCurrent,
      from_time: dateCurrent === fromDateFormat ? fromTimeFormat : "00:00:00",
      to_time: dateCurrent === toDateFormat ? toTimeFormat : "23:59:00",
    });
  }

  return result;
}

export function checkEnoughADay(fromTimeStr, toTimeStr) {
  const fromTime = moment(fromTimeStr, "HH:mm:ss");
  const toTime = moment(toTimeStr, "HH:mm:ss");

  const duration = moment.duration(toTime.diff(fromTime));

  const requiredDuration = moment.duration({ hours: 23, minutes: 59 });
  const isEnoughTime =
    duration.asMilliseconds() >= requiredDuration.asMilliseconds();

  return isEnoughTime;
}

export function checkIsHolidayAndNotValidTimelot(listHoliday, date, time_slot) {
  const dateFormated = moment(date).format("YYYY-MM-DD");

  const findDate = listHoliday.find(holiday => holiday.date === dateFormated);

  if (findDate && isTimeOverlap(time_slot, findDate)) {
    return true;
  }

  return false;
}

const toInt = string => {
  if (string) {
    return parseInt(string);
  }

  return null;
};

export const convertTime = value => {
  const formTime = moment(value, "HH:mm:ss");

  const hour = toInt(formTime.format("HH"));
  const minute = toInt(formTime.format("mm"));

  return { hour, minute };
};

export const getTimeSlot = ({
  timeSlotOptions,
  date,
  useTimeSlotRule,
  holidays,
  isGrab,
  isHCMOrder,
  isCheckHolidayAndNotValid = true,
}) => {
  const dateCurrent = moment().startOf("day");
  const dateCollection = moment(date).startOf("day");
  let minValid = 0;
  if (isHCMOrder) {
    minValid = 45;
    const is_grab = isGrab;
    if (is_grab) {
      minValid = 20;
    }
  }

  const timeValid = moment(Date()).add(minValid, "minute");
  const hourValid = toInt(timeValid.format("HH"));
  const minuteValid = toInt(timeValid.format("mm"));

  if (dateCollection.isSame(dateCurrent) && useTimeSlotRule) {
    return timeSlotOptions?.filter(timeslot => {
      if (
        isCheckHolidayAndNotValid &&
        checkIsHolidayAndNotValidTimelot(holidays, date, timeslot.value)
      )
        return false;
      if (isHCMOrder) {
        if (timeslot?.value?.type == TIME_SLOT_TYPE.RUNNER) {
          const { hour, minute } = convertTime(timeslot?.value?.from_time);

          return (
            (hour == hourValid && minute >= minuteValid) || hour > hourValid
          );
        } else if (timeslot?.value?.type == TIME_SLOT_TYPE.COORDINATE) {
          const { hour, minute } = convertTime(timeslot?.value?.to_time);

          return (
            (hour == hourValid && minute >= minuteValid) || hour > hourValid
          );
        }
      } else {
        if (
          timeslot?.value?.type == TIME_SLOT_TYPE.DVVC ||
          timeslot?.value?.type == TIME_SLOT_TYPE.BUS
        ) {
          const { hour, minute } = convertTime(timeslot?.value?.to_time);
          return (
            (hour == hourValid && minute >= minuteValid) || hour > hourValid
          );
        }
      }
      return false;
    });
  } else {
    return timeSlotOptions?.filter(timeslot => {
      if (
        isCheckHolidayAndNotValid &&
        checkIsHolidayAndNotValidTimelot(holidays, date, timeslot.value)
      )
        return false;

      if (isHCMOrder) {
        return (
          timeslot?.value?.type == TIME_SLOT_TYPE.RUNNER ||
          timeslot?.value?.type == TIME_SLOT_TYPE.COORDINATE
        );
      } else {
        return (
          timeslot?.value?.type == TIME_SLOT_TYPE.DVVC ||
          timeslot?.value?.type == TIME_SLOT_TYPE.BUS
        );
      }
    });
  }
};

export const isAnyShift = ({
  timeSlotOptions,
  date,
  useTimeSlotRule,
  holidays,
  isGrab,
  isHCMOrder,
}) => {
  const timeSlot = getTimeSlot({
    timeSlotOptions: timeSlotOptions,
    date: date,
    useTimeSlotRule: useTimeSlotRule,
    holidays: holidays,
    isGrab: isGrab,
    isHCMOrder: isHCMOrder,
  });
  return timeSlot && timeSlot.length > 0;
};

function isTimeOverlap(object1, object2) {
  const fromTime1 = Date.parse(`01/01/1970 ${object1.from_time}`);
  const toTime1 = Date.parse(`01/01/1970 ${object1.to_time}`);
  const fromTime2 = Date.parse(`01/01/1970 ${object2.from_time}`);
  const toTime2 = Date.parse(`01/01/1970 ${object2.to_time}`);

  if (
    (fromTime1 <= fromTime2 && fromTime2 <= toTime1) ||
    (fromTime1 <= toTime2 && toTime2 <= toTime1) ||
    (fromTime2 <= fromTime1 && fromTime1 <= toTime2) ||
    (fromTime2 <= toTime1 && toTime1 <= toTime2)
  ) {
    return true; // Có sự trùng lặp
  } else {
    return false; // Không có sự trùng lặp
  }
}

export function splitTwoLine(text) {
  const length = 50;
  if (text.length <= length) {
    return [text];
  }

  const words = text.split(" ");
  let line1 = "";
  let line2 = "";

  for (let i = 0; i < words.length; i++) {
    const tempLine = line1 + words[i] + " ";
    if (tempLine.length <= length) {
      line1 = tempLine;
    } else {
      line2 += words[i] + " ";
    }
  }

  return [line1.trim(), line2.trim()];
}

export function splitText(text, config) {
  let widthLimit = 0;
  let textLength = 200;
  if (config && config.length) {
    config.forEach(item => {
      if (window.innerWidth <= item.limit_width) {
        widthLimit = item.limit_width;
        textLength = item.limit_text_length;
      }
    });
  }
  const withLimitCondition = Boolean(widthLimit)
    ? window.innerWidth <= widthLimit
    : true;
  const textLengthCondition = text.length > textLength;

  if (withLimitCondition && textLengthCondition) {
    let midIndex = Math.ceil(text.length / 2); // Tìm chỉ mục trung tâm của chuỗi
    let breakIndex = text.lastIndexOf(" ", midIndex); // Tìm dấu cách gần trung tâm
    if (breakIndex !== -1) {
      let firstLine = text.substring(0, breakIndex);
      let secondLine = text.substring(breakIndex + 1);
      return firstLine + "<br>" + secondLine;
    }
  }

  return text;
}

export const getTransportTrackingLink = (format, refCode) => {
  if (format && refCode) {
    return format.replace(REF_CODE_PATTERN, refCode);
  }

  return undefined;
};

export const filteredObject = (originalObject, prefixesToRemove) =>
  Object.fromEntries(
    Object.entries(originalObject).filter(
      ([key, value]) => !prefixesToRemove.some(prefix => key.startsWith(prefix))
    )
  );

export function modifiedDateTime(og, prefixKey) {
  const result = {};

  Object.keys(og).forEach(key => {
    if (key.startsWith(prefixKey)) {
      const timeCondition = key.slice(prefixKey.length); // Lấy phần sau của prefixKey
      let value = og[key];

      if (timeCondition === "[gte]" || timeCondition === "[gt]") {
        value += " 00:00:00";
      } else if (timeCondition === "[lte]" || timeCondition === "[lt]") {
        value += " 23:59:00";
      }

      result[key] = value;
    }
  });

  return result;
}
